import { Reducer } from 'redux';
import { LandingCheckoutStatusEnum } from '@dev/ee-api/ee-api-models';
import { CheckoutsActionTypes, CheckoutListState, UpdateCheckoutStatusSuccessAction, UpdateCheckoutStatusStartAction, UpdateCheckoutStatusErrorAction } from './types';

export const CheckoutsInitialState: CheckoutListState = {
    loadingTemplates: false,
    loadingTemplate: false,
    previewLoading: false,
    templatesList: [],
    count: 0,
    DeletingTemplate: false,
    name: null,
    template: null,
    ispublic: false,
    removeScreenshot: true,
    checkedCheckouts: [],
    checkout: null,
    publishedCount: 0,
    unpublishedCount: 0
};

const updateCheckoutStart = (state: CheckoutListState, action: UpdateCheckoutStatusStartAction) => {
    const updatedTemplatesList = state.templatesList.map((checkout) => 
        checkout.Name === action.payload.name
            ? { ...checkout, isChangingStatus: true }
            : checkout
    );

    return {
        ...state,
        templatesList: updatedTemplatesList
    };
}

const updateCheckoutSuccess = (state: CheckoutListState, action: UpdateCheckoutStatusSuccessAction) => {
        const updatedTemplatesList = state.templatesList.map((checkout) => 
            checkout.Name === action.payload.name
                ? { ...checkout, Status: action.payload.status, isChangingStatus: false }
                : checkout
        );

        let newPublishedCount = state.publishedCount;
        let newUnpublishedCount = state.unpublishedCount;

        if (action.payload.status === LandingCheckoutStatusEnum.Published) {
            newPublishedCount += 1;
            newUnpublishedCount -= 1;
        } else if (action.payload.status === LandingCheckoutStatusEnum.Unpublished) {
            newPublishedCount -= 1;
            newUnpublishedCount += 1;
        }

        return {
            ...state,
            templatesList: updatedTemplatesList,
            publishedCount: newPublishedCount,
            unpublishedCount: newUnpublishedCount,
        };
}

const updateCheckoutError = (state: CheckoutListState, action: UpdateCheckoutStatusErrorAction) => {
    const updatedTemplatesList = state.templatesList.map((checkout) => 
        checkout.Name === action.payload.name
            ? { ...checkout, isChangingStatus: false }
            : checkout
    );

    return {
        ...state,
        templatesList: updatedTemplatesList
    };
}

const reducer: Reducer<CheckoutListState> = (
    state: CheckoutListState = CheckoutsInitialState,
    action
): CheckoutListState => {
    switch (action.type) {
        case CheckoutsActionTypes.PICK_CHECKOUTS:
            return { ...state, checkedCheckouts: action.payload.checkedCheckouts };
        case CheckoutsActionTypes.UNPICK_CHECKOUTS:
            return { ...state, checkedCheckouts: [] };  
        case CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE_SUCCESS:
            return { ...state, checkout: action.payload.checkout, previewLoading: action.payload.previewLoading}
        case CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS:
            return updateCheckoutStart(state, action as UpdateCheckoutStatusStartAction)
        case CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS_SUCCESS: 
            return updateCheckoutSuccess(state, action as UpdateCheckoutStatusSuccessAction)
        case CheckoutsActionTypes.UPDATE_CHECKOUT_STATUS_ERROR:
            return updateCheckoutError(state, action as UpdateCheckoutStatusErrorAction)
        case CheckoutsActionTypes.GET_ALL_CHECKOUTS_START:
        case CheckoutsActionTypes.GET_ALL_CHECKOUTS_SUCCESS:  
        case CheckoutsActionTypes.GET_ALL_CHECKOUTS_ERROR: 
        case CheckoutsActionTypes.DELETE_CHECKOUTS:
        case CheckoutsActionTypes.DELETE_CHECKOUTS_ERROR:
        case CheckoutsActionTypes.DELETE_CHECKOUTS_SUCCESS:
        case CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_START:
        case CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_SUCCESS:
        case CheckoutsActionTypes.GET_CHECKOUT_BY_NAME_ERROR:
        case CheckoutsActionTypes.CLEAR_PREVIEW_TEMPLATE:
        case CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE:
        case CheckoutsActionTypes.LOAD_PREVIEW_TEMPLATE_ERROR:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export { reducer as checkoutsList };

export default reducer;
